// export const url = 'http://localhost/ViasatBack';
export const url = 'https://intralplugins.com/Viasat/CustomerAppBack';
